<div class="wrap">
	<div class="qo-flex-row-center-left qo-padding30 popup-header">
		<qo-icon
			class="sticky-img"
			[icon]="EQORebrandIcon.info_dark"
			[invertedScheme]="true"
			[scheme]="EQORebrandColor.SECONDARY"
			[color]="EQORebrandColor.SECONDARY"
			[size]="'sm'"
		></qo-icon>
		<h1 class="qo-margin-left20">
			{{'entering_online_ordering_module_title' | translate}}
		</h1>
	</div>
	<div class="qo-flex-col-center-left qo-padding30">
		<div>
			{{'entering_online_ordering_module_description_1' | translate}}
		</div>
		<div class="qo-margin-top20">
			{{'entering_online_ordering_module_description_2' | translate}}
		</div>
		<div class="qo-margin-top20">
			{{'entering_online_ordering_module_description_3' | translate}}
		</div>
		<div>
			Shopbox
		</div>
	</div>
	<div class="qo-flex-row-center-right qo-padding30">
		<button
			class="qo-button-standard qo-grey"
			(click)="dialog.close(false)"
		>
			{{'cancel_all' | translate}}
		</button>
		<button
			class="qo-button-standard qo-primary qo-margin-left30"
			(click)="dialog.close(true)"
		>
			{{'continue_all' | translate}}
		</button>
	</div>
</div>
